import React, {useEffect, useState} from 'react'
import '../App.css'
function App({handleSetFloor, isLast, floorName, isCompleted, isMission, subText, missionNum, floorRef}) {
    const styleObj = {
        marginTop: isLast ? 0 : '10%',
        // boxShadow: isMission && !isCompleted ? '0 0 15px 4px #fab405' : 'none',
    }
    return(
    <div id={isMission ? 'target' : ''} key={floorName} onClick={() => handleSetFloor(missionNum || null)}className={'relative border border-[#c09d46] bg-[#c09d4680] rounded-xl h-[23%] w-full mt-[10%] flex flex-col items-center justify-center ' + (isMission && !isCompleted ? 'floor-glow' : '')} style={styleObj}>
        <div className='text-[27px] font-[700] text-[#0d3b61]'>{floorName}</div>
        <div className='text-[12px] font-[500] text-[#0d3b61]'>{subText}</div>
        {(missionNum === 1 && !isCompleted) && <img src={'/images/mission.png'} className='w-[30%] absolute right-[5%]'></img>}
        {/* {(missionNum === 2 && !isCompleted) && <img src={'/level_2.png'} className='w-[30%] absolute right-[5%]'></img>} */}
        {isCompleted && <img src={'/done_1.png'} className='w-[30%] absolute right-[5%]'></img>}
    </div>)
}
//ref={isMission ? floorRef : null}
export default App;